import type { LancarPOSDatabase } from '@lancar-pos/db-schema';

const SAMPLE_UNITS = [
  { id: 'unit-1', name: 'Pieces', abbreviation: 'pcs', type: 'count', isDefault: true },
  { id: 'unit-2', name: 'Kilogram', abbreviation: 'kg', type: 'weight', isDefault: false },
  { id: 'unit-3', name: 'Gram', abbreviation: 'g', type: 'weight', isDefault: false },
  { id: 'unit-4', name: 'Liter', abbreviation: 'L', type: 'volume', isDefault: false },
  { id: 'unit-5', name: 'Milliliter', abbreviation: 'mL', type: 'volume', isDefault: false },
  { id: 'unit-6', name: 'Gelas', abbreviation: 'gelas', type: 'count', isDefault: false },
  { id: 'unit-7', name: 'Piring', abbreviation: 'piring', type: 'count', isDefault: false },
  { id: 'unit-8', name: 'Porsi', abbreviation: 'porsi', type: 'count', isDefault: false },
  { id: 'unit-9', name: 'Irisan', abbreviation: 'iris', type: 'count', isDefault: false },
  { id: 'unit-10', name: 'Potongan', abbreviation: 'potong', type: 'count', isDefault: false },
  { id: 'unit-11', name: 'Scoop', abbreviation: 'scoop', type: 'count', isDefault: false },
];

const SAMPLE_CATEGORIES = [
  { id: 'cat-1', name: 'Minuman', color: '#3B82F6', icon: '☕', sortOrder: 1 },
  { id: 'cat-2', name: 'Makanan', color: '#10B981', icon: '🍴', sortOrder: 2 },
  { id: 'cat-3', name: 'Snack', color: '#F59E0B', icon: '🍿', sortOrder: 3 },
  { id: 'cat-4', name: 'Dessert', color: '#EC4899', icon: '🎂', sortOrder: 4 },
];

const SAMPLE_PRODUCTS = [
  { id: 'prod-1', name: 'Kopi Latte', sku: 'KOP-LAT', barcode: '8991001', price: 25000, cost: 12000, categoryId: 'cat-1', unit: 'gelas', stock: 50, minStock: 10, isActive: true },
  { id: 'prod-2', name: 'Cappuccino', sku: 'KOP-CAP', barcode: '8991002', price: 25000, cost: 12000, categoryId: 'cat-1', unit: 'gelas', stock: 50, minStock: 10, isActive: true },
  { id: 'prod-3', name: 'Espresso', sku: 'KOP-ESP', barcode: '8991003', price: 20000, cost: 10000, categoryId: 'cat-1', unit: 'gelas', stock: 50, minStock: 10, isActive: true },
  { id: 'prod-4', name: 'Americano', sku: 'KOP-AME', barcode: '8991004', price: 22000, cost: 11000, categoryId: 'cat-1', unit: 'gelas', stock: 50, minStock: 10, isActive: true },
  { id: 'prod-5', name: 'Es Teh Manis', sku: 'MIN-ETM', barcode: '8992001', price: 15000, cost: 5000, categoryId: 'cat-1', unit: 'gelas', stock: 100, minStock: 20, isActive: true },
  { id: 'prod-6', name: 'Es Jeruk', sku: 'MIN-EJR', barcode: '8992002', price: 18000, cost: 7000, categoryId: 'cat-1', unit: 'gelas', stock: 100, minStock: 20, isActive: true },
  { id: 'prod-7', name: 'Nasi Goreng', sku: 'MKN-NGR', barcode: '8993001', price: 35000, cost: 18000, categoryId: 'cat-2', unit: 'piring', stock: 30, minStock: 5, isActive: true },
  { id: 'prod-8', name: 'Mie Goreng', sku: 'MKN-MGR', barcode: '8993002', price: 32000, cost: 15000, categoryId: 'cat-2', unit: 'piring', stock: 30, minStock: 5, isActive: true },
  { id: 'prod-9', name: 'Ayam Goreng', sku: 'MKN-AYG', barcode: '8993003', price: 40000, cost: 22000, categoryId: 'cat-2', unit: 'porsi', stock: 20, minStock: 5, isActive: true },
  { id: 'prod-10', name: 'Roti Bakar', sku: 'SNK-RTB', barcode: '8994001', price: 20000, cost: 8000, categoryId: 'cat-3', unit: 'porsi', stock: 40, minStock: 10, isActive: true },
  { id: 'prod-11', name: 'Kentang Goreng', sku: 'SNK-KTG', barcode: '8994002', price: 25000, cost: 10000, categoryId: 'cat-3', unit: 'porsi', stock: 40, minStock: 10, isActive: true },
  { id: 'prod-12', name: 'Pisang Goreng', sku: 'SNK-PSG', barcode: '8994003', price: 15000, cost: 5000, categoryId: 'cat-3', unit: 'porsi', stock: 40, minStock: 10, isActive: true },
  { id: 'prod-13', name: 'Cheesecake', sku: 'DES-CHK', barcode: '8995001', price: 35000, cost: 18000, categoryId: 'cat-4', unit: 'iris', stock: 15, minStock: 5, isActive: true },
  { id: 'prod-14', name: 'Brownies', sku: 'DES-BRW', barcode: '8995002', price: 30000, cost: 15000, categoryId: 'cat-4', unit: 'potong', stock: 15, minStock: 5, isActive: true },
  { id: 'prod-15', name: 'Ice Cream', sku: 'DES-ICR', barcode: '8995003', price: 20000, cost: 8000, categoryId: 'cat-4', unit: 'scoop', stock: 50, minStock: 10, isActive: true },
  { id: 'prod-16', name: 'Produk Habis', sku: 'TST-HBS', barcode: '8999999', price: 10000, cost: 5000, categoryId: 'cat-1', unit: 'pcs', stock: 0, minStock: 0, isActive: true },
];

export async function seedSampleData(db: LancarPOSDatabase): Promise<void> {
  const now = new Date().toISOString();

  // Seed units first
  const existingUnits = await db.units.find().exec();
  if (existingUnits.length === 0) {
    await db.units.bulkInsert(
      SAMPLE_UNITS.map((unit) => ({
        ...unit,
        createdAt: now,
        updatedAt: now,
        _deleted: false,
      }))
    );
    console.log('Seeded sample units');
  }

  const existingCategories = await db.categories.find().exec();
  if (existingCategories.length === 0) {
    await db.categories.bulkInsert(
      SAMPLE_CATEGORIES.map((cat) => ({
        ...cat,
        parentId: null,
        createdAt: now,
        updatedAt: now,
        _deleted: false,
      }))
    );
    console.log('Seeded sample categories');
  }

  const existingProducts = await db.products.find().exec();
  if (existingProducts.length === 0) {
    await db.products.bulkInsert(
      SAMPLE_PRODUCTS.map((prod) => ({
        ...prod,
        imageUrl: null,
        variants: [],
        bomItems: [],
        createdAt: now,
        updatedAt: now,
        _deleted: false,
      }))
    );
    console.log('Seeded sample products');
  }

  const businessName = await db.settings.findOne('business_name').exec();
  if (!businessName) {
    await db.settings.bulkInsert([
      { id: 'business_name', key: 'business_name', value: 'Kedai Kopi Jaya', category: 'business', updatedAt: now },
      { id: 'business_type', key: 'business_type', value: 'coffee_shop', category: 'business', updatedAt: now },
      { id: 'business_address', key: 'business_address', value: 'Jl. Sudirman No. 123, Jakarta', category: 'business', updatedAt: now },
      { id: 'business_phone', key: 'business_phone', value: '08123456789', category: 'business', updatedAt: now },
      { id: 'tax_rate', key: 'tax_rate', value: 11, category: 'tax', updatedAt: now },
      { id: 'tax_enabled', key: 'tax_enabled', value: true, category: 'tax', updatedAt: now },
    ]);
    console.log('Seeded sample settings');
  }
}
